<template>
  <div class="tabbar-wrapper">
    <div class="tabbar">
      <router-link to="/" class="tab-item" :class="{ active: currentRoute === '/' }">
        <svg class="tab-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
        <span class="tab-label">Explore</span>
      </router-link>
      
      <router-link to="/favorites" class="tab-item" :class="{ active: currentRoute === '/favorites' }">
        <svg class="tab-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
        <span class="tab-label">Favorites</span>
      </router-link>
      
      <router-link to="/snags" class="tab-item" :class="{ active: currentRoute === '/snags' }">
        <svg class="tab-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="m21 11-8-8H2v11l8 8Z"></path>
          <path d="M7 7h.01"></path>
        </svg>
        <span class="tab-label">Orders</span>
      </router-link>
      
      <router-link to="/wallet" class="tab-item" :class="{ active: currentRoute === '/wallet' }">
        <svg class="tab-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="2" y="4" width="20" height="16" rx="2"></rect>
          <path d="M7 15h0M2 9.5h20"></path>
        </svg>
        <span class="tab-label">Points</span>
      </router-link>
      
      <router-link to="/account" class="tab-item" :class="{ active: currentRoute === '/account' }">
        <svg class="tab-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
        <span class="tab-label">Account</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabBar',
  computed: {
    currentRoute() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
.tabbar-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: white;
  border-top: 1px solid #e0e0e0;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding-bottom: env(safe-area-inset-bottom);
}

.tabbar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 60px;
  max-width: 100%;
  margin: 0 auto;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-decoration: none;
  color: #999;
  transition: color 0.3s;
  padding: 5px;
}

.tab-item.active {
  color: #00d4aa;
}

.tab-icon {
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
  stroke: currentColor;
}

.tab-label {
  font-size: 11px;
  font-weight: 500;
  text-align: center;
}

/* 桌面端隐藏 TabBar */
@media (min-width: 768px) {
  .tabbar-wrapper {
    display: none;
  }
}
</style>
